import { ComponentProps, useContext, forwardRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Button as AltoButton } from '@alto-avios/alto-ui';
import { mergeProps } from '@react-aria/utils';

import { useRouterLink } from '../../contexts/router';

import { ButtonContext } from './ButtonContext';

export type ButtonProps = Omit<ComponentProps<typeof AltoButton>, 'as'> & {
  disableRouting?: boolean;
};

export const Button = forwardRef(({ children, disableRouting, ...props }: ButtonProps, ref) => {
  const contextProps = useContext(ButtonContext);
  const buttonProps = mergeProps(props, useRouterLink({ href: props.href, disableRouting }), contextProps ?? {});

  return (
    <AltoButton {...buttonProps} ref={ref}>
      {children}
    </AltoButton>
  );
});
